import { Box, Flex, Skeleton, Stack } from '@hivewatch/dark'

const LabelledFieldSkeleton = ({ fieldHeight }: { fieldHeight: string }) => (
  <Stack gap='6px' w='full'>
    <Skeleton h='16px' maxW='120px' />
    <Skeleton h={fieldHeight} w='full' />
  </Stack>
)

/**
 * Loading placeholder for AnnouncementBannerSection. Mirrors the form's layout
 * (message, type, the two date/time rows, and the action button) so the section
 * doesn't reflow when the product-message query resolves. Skeleton themes off
 * the surrounding DarkProvider's colorScheme, so no mode prop is needed.
 */
export const AnnouncementBannerSkeleton = () => (
  <Stack data-testid='AnnouncementBanner:skeleton' gap='16px' w='full'>
    <LabelledFieldSkeleton fieldHeight='96px' />
    <LabelledFieldSkeleton fieldHeight='40px' />

    <Flex gap='16px' w='full'>
      <Box flex='1'>
        <LabelledFieldSkeleton fieldHeight='40px' />
      </Box>
      <Box flex='1'>
        <LabelledFieldSkeleton fieldHeight='40px' />
      </Box>
    </Flex>

    <Flex gap='16px' w='full'>
      <Box flex='1'>
        <LabelledFieldSkeleton fieldHeight='40px' />
      </Box>
      <Box flex='1'>
        <LabelledFieldSkeleton fieldHeight='40px' />
      </Box>
    </Flex>

    <Skeleton h='40px' maxW='120px' />
  </Stack>
)
